import styled from "styled-components";

export const StyledRange = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px 0;
  label {
    font-size: 14px;
    margin-bottom: 16px;
    font-weight: 500;
  }
`;
